'use client';

import React from 'react';
import Image from 'next/image';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useI18n } from '@/hooks/use-i18n';

interface LearnMoreModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LearnMoreModal: React.FC<LearnMoreModalProps> = ({ isOpen, onClose }) => {
  const { t } = useI18n('template');
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="w-[640px] px-6 py-0 gap-0" hideCloseButton>
        <DialogHeader>
          <DialogTitle className="text-center text-[18px] font-semibold h-[56px] leading-[56px] mb-[14px]">
            {t('taskTemplate.learnMore.title')}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6 text-[14px] text-[#000000BF] mb-[22px]">
          <div>{t('taskTemplate.learnMore.description')}</div>

          <div className="space-y-2">
            <div>{t('taskTemplate.learnMore.whyUse')}</div>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <span>{t('taskTemplate.learnMore.saveTime')}</span>
                {t('taskTemplate.learnMore.saveTimeDesc')}
              </li>
              <li>
                <span>{t('taskTemplate.learnMore.quality')}</span>
                {t('taskTemplate.learnMore.qualityDesc')}
              </li>
              <li>
                <span>{t('taskTemplate.learnMore.share')}</span>
                {t('taskTemplate.learnMore.shareDesc')}
              </li>
            </ul>
          </div>

          <div className="space-y-2">
            <div>{t('taskTemplate.learnMore.howToUse')}</div>
            <div>{t('taskTemplate.learnMore.howToUseDesc')}</div>
          </div>
        </div>

        <DialogFooter className="h-22 flex items-center">
          <Button onClick={onClose} className="bg-primary hover:bg-primary/90">
            {t('taskTemplate.learnMore.gotIt')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LearnMoreModal;
